let params = window.location.search
  .substring( 1 )
  .split( '&' )
  .map( param => {
    return param.split( '=' )
  } )
  


let lang = ( () => {
  for ( var i = 0; i < params.length; i++ ) {
    if ( params[ i ][ 0 ] === 'lang' ) {
      lang = params[ i ][ 1 ]
      if ( lang === 'ru' || lang === 'en' || lang === 'cn' ) {
        return lang
      }
    }
  }

  var browserLang = navigator.language || navigator.userLanguage
	var path = window.location.pathname.substring( 1 )
	
	
	if ( path === 'cn' || path === 'cn/' || [ 'zh-cht', 'zh-chs', 'zh-cn', 'zh', 'zh-hk', 'zh-mo', 'zh-tw', 'zh-sg' ].includes( browserLang.toLowerCase() ) ) {
		return 'cn'
	} else if ( ( browserLang === 'ru-RU'  || browserLang === 'ru' || browserLang === 'ru-ru' ) ) {
		return 'ru'
  } else {
    return 'en'
  }
} )();

console.log(lang)

export default lang


// WEBPACK FOOTER //
// ./src/lang/takeLang.js